import { useStore } from '@stores';
import { useEffect } from 'react';

export const useMotHistoryByVin = (vin?: string) => {
  const { vehicleStore } = useStore();
  const { motHistory, averageMonthlyMileage } = vehicleStore;

  useEffect(() => {
    vin && vehicleStore.getMotHistoryByVin(vin);

    return () => {
      vehicleStore.clearMotHistory();
    };
  }, [vehicleStore, vin]);

  return { motHistory, averageMonthlyMileage };
};
